import { z } from "zod";

export enum PaymentStatus {
  UNKNOWN = "Unknown",
  UNPAID = "Unpaid",
  AWAITING_PAYMENT = "Awaiting_payment",
  PAID = "Paid",
  FAILED = "Failed",
}

export enum PaymentMethod {
  AUTOPAY = "Autopay",
  HOTPAY = "HotPay",
  CASH = "Cash",
  CARD = "Card",
  BLIK = "BLIK",
}

export const PaymentMethodLabels: Record<PaymentMethod, string> = {
  [PaymentMethod.AUTOPAY]: "Autopay",
  [PaymentMethod.HOTPAY]: "HotPay",
  [PaymentMethod.CASH]: "Gotówka",
  [PaymentMethod.CARD]: "Karta",
  [PaymentMethod.BLIK]: "BLIK",
};

const PaymentBaseSchema = z.object({
  status: z.nativeEnum(PaymentStatus).nullish(),
  method: z.nativeEnum(PaymentMethod),
});

export const PaymentResponseSchema = PaymentBaseSchema.extend({
  id: z.number(),
});

export const PaymentFormSchema = PaymentBaseSchema.extend({
  id: z.number().optional(), //im fucking lazy ok?
  method: z.nativeEnum(PaymentMethod, {
    errorMap: () => ({ message: "validation.payment.method_required" }),
  }),
});

export const PaymentInitResponseSchema = z.object({
  url: z.string(),
  method: z.enum(["POST", "GET"]),
  payload: z.record(z.string()),
});

export type PaymentInitResponse = z.infer<typeof PaymentInitResponseSchema>;

export const AutopayWhiteLabelResponseSchema = z.object({
  order_id: z.string(),
  remote_id: z.string(),
  confirmation: z.enum(["CONFIRMED", "NOTCONFIRMED"]),
  reason: z.string(),
  payment_status: z
    .enum(["PENDING", "SUCCESS", "FAILURE"])
    .nullable()
    .optional(),
  redirect_url: z.string(),
  blik_aliases: z.array(z.object({ key: z.string(), label: z.string() })),
});

export type AutopayWhiteLabelResponse = z.infer<
  typeof AutopayWhiteLabelResponseSchema
>;

export type PaymentInitPayload = {
  payment_id: number;
  return_url?: string;
  email?: string;
  customer_data?: string;
  service_name?: string;
};

export type AutopayBlikWhiteLabelPayload = PaymentInitPayload & {
  authorization_code: string;
};
